import React from "react";
import QRCode from "react-qr-code";

import './Show.css';

import UserContext from '@components/context/userContext';
import configService from '@services/config';

class ComponentToPrint extends React.Component {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            empresa: {}
        };
        this.loadFunction = this.loadFunction.bind(this);
    }

    async loadFunction() {
        const profile = this.context;

        if (!this.state.loaded) {
            try {
                const configData = await configService.get(profile.idEmpresa);
                const empresa = Array.isArray(configData) && configData.length > 0 ? configData[0] : {};
                this.setState({ empresa, loaded: true });
            } catch (error) {
                console.error(error);
            }
        }
    }

    componentDidMount() {
        this.props.handleDidMount();
    }

    render() {
        const { data, customer, employee, currency } = this.props;
        const { empresa } = this.state;

        this.loadFunction()


        // Tentar diferentes estruturas de dados possíveis
        let valuesArray = null;
        
        if (data && data.values && Array.isArray(data.values)) {
            valuesArray = data.values;
        } else if (data && data.data && data.data.values && Array.isArray(data.data.values)) {
            valuesArray = data.data.values;
        } else if (Array.isArray(data)) {
            valuesArray = data;
        } else if (data && Array.isArray(data)) {
            valuesArray = data;
        }

        // Verificar se temos dados válidos
        if (!valuesArray || valuesArray.length === 0) {
            return (
                <div className="fullTickets">
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <p>Nenhum dado disponível para impressão.</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="fullTickets">
                {valuesArray.map((value, valueIndex) => 
                    value.qr && value.qr.map((eachQr, index) => (
                    <div className="ticket" key={`${valueIndex}-${index}-${eachQr.idticket || index}`}>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td rowSpan="2" className="ticketLogo">
                                        <img
                                            className="ticketLogo"
                                            src={ 'https://eposgestofinal.com/' + (empresa['avatar'] || 'site/images/suitcase.png')}
                                            alt={ empresa['nomeempresa'] }
                                        />
                                    </td>
                                    <td style={{ fontSize: '7pt', fontWeight: 'bolder' }}>
                                        { empresa['nomeempresa'] }
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: '5pt' }}>
                                        { empresa['address'] }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="ticketData">
                            <div><span>Cliente:</span> {customer}</div>
                            <div><span>Data:</span> {eachQr['created_at']} <span>Op:</span> {employee}</div>
                        </div>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td rowSpan="3" style={{ width: '120px' }}>
                                        <QRCode
                                            size={95}
                                            value={eachQr['code']}
                                        />
                                        <div className="ticketValue">{currency} {value.value}</div>
                                        <div className="refValue">Ref: {eachQr['idticket']}</div>
                                    </td>
                                    <td style={{ textAlign: 'left', height: '35px', border: 'none', borderBottom: '1px solid #000' }}><span>Data:</span></td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left', height: '35px', border: 'none', borderBottom: '1px solid #000' }}><span>Bombeiro:</span></td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left', height: '35px', border: 'none', borderBottom: '1px solid #000' }}><span>Cliente:</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )))}
            </div>
        )
    }
}

export default ComponentToPrint;
